<script context="module">import * as Highcharts from "highcharts";
import * as HighchartsMap from "highcharts/highmaps";
import { browser } from "$app/environment";
import { onMount, onDestroy, createEventDispatcher } from "svelte";
let highcharts;
if (browser) {
  import("highcharts").then((highcharts2) => highcharts2 = highcharts2.default);
}
export { highcharts as Highcharts };
</script>

<script>export let options;
export let animate = true;
export let chartType = "map";
let prevOptions;
let prevSeries;
let ref;
let chart;
const dispatch = createEventDispatcher();
onMount(async () => {
  if (!highcharts) {
    if (chartType === "map") {
      await import("highcharts");
    } else {
      await import("highcharts/modules/map");
    }
  }
  chart = chartType === "map" ? Highcharts.chart(ref, { ...options }) : HighchartsMap.mapChart(ref, { ...options });
  dispatch("chartCreated", chart);
});
onDestroy(() => {
  chart?.destroy();
});
$: {
  if (chart && options && options !== prevOptions) {
    chart.series[0].update({ ...options }, animate);
  }
  prevOptions = options;
}
</script>

<div bind:this={ref} />
